import { TDocFile } from 'shared/constants/docs';
import { Cloud } from 'shared/_model/cloud/types';

// eslint-disable-next-line import/prefer-default-export
export function getFileThumbnailImage(file: TDocFile): Cloud | undefined {
	const thumbnailCloud = file.thumbnail?.cloud;
	const fileImage = (file as any).image; // TODO: remove old code when data is transfered in DB to new place
	const image = thumbnailCloud ?? (fileImage ? { s3: fileImage } : undefined);

	return image;
}
